<template>
  <section class="section-shaped my-0">
      <div 
      style="background-color:#e73273"
      class="shape shape-style-1">
      </div>
      <div class="container shape-container d-flex">
          <div class="col px-0">
              <div class="row">
                  <div class="col-lg-6 pb-5">
                      <h1 class="display-3  text-white"> {{title}}
                          <span class="mt-3"> {{subtitle}} </span>
                      </h1>
                  </div>
              </div>
          </div>
      </div>
  </section>
</template>

<style lang="scss" module>

</style>

<script>

export default {
  props: {
    title: {
      type: String,
    },
    subtitle: {
      type: String,
    },  
  }  
}

</script>
